import React from "react";
import { NavLink, Outlet, Link, Navigate, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Package, Ticket, FileText, Settings as SettingsIcon,
  ShoppingCart, Inbox, LogOut, ExternalLink,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import "@/admin.css";

const NAV = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true },
  { to: "/admin/produits", label: "Produits", icon: Package },
  { to: "/admin/promotions", label: "Codes promo", icon: Ticket },
  { to: "/admin/blog", label: "Blog", icon: FileText },
  { to: "/admin/contenu", label: "Contenu du site", icon: SettingsIcon },
  { to: "/admin/commandes", label: "Commandes", icon: ShoppingCart },
  { to: "/admin/messages", label: "Messages", icon: Inbox },
];

export default function AdminLayout() {
  const { user, ready, logout } = useAuth();
  const navigate = useNavigate();

  if (!ready) {
    return <div className="adm-loader"><div className="spinner" /></div>;
  }
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-brand">Nerolya <em>Cosmetic</em></div>
        <nav className="admin-nav" data-testid="admin-nav">
          {NAV.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => (isActive ? "active" : "")} data-testid={`adminnav-${n.label.toLowerCase().replace(/\s/g, "-")}`}>
                <Icon size={17} /> <span>{n.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className="admin-sidebar-footer">
          <button className="admin-logout" onClick={handleLogout} data-testid="admin-logout"><LogOut size={14} style={{ display: "inline", verticalAlign: "middle", marginRight: 6 }} />Déconnexion</button>
        </div>
      </aside>

      <main className="admin-main">
        <div className="admin-topbar">
          <div />
          <Link to="/" target="_blank" className="admin-view-site"><ExternalLink size={13} style={{ display: "inline", verticalAlign: "middle", marginRight: 5 }} />Voir le site</Link>
        </div>
        <Outlet />
      </main>
    </div>
  );
}
